import { Statistic } from "antd";

import './TimeoutCountdown.scss'

const TimeoutCountdown = (props) => {
    return <Statistic.Countdown value={props.value} format="s" />
}

export default TimeoutCountdown;